import type { Socket } from "socket.io-client"

export interface IntradayStandalonePerformanceItem {
  returnPercent: number | null
  currencyPerformance: number | null
  factorsReturnPercent: number | null
  specificReturnPercent: number | null
}

export type StandalonePerformanceByModelProviderId = Record<string, IntradayStandalonePerformanceItem>
export type StandalonePerformanceByPeriod = Record<string, StandalonePerformanceByModelProviderId>

export const STANDALONE_PERFORMANCE_UPDATED_EVENT = "standalonePerformanceUpdated"
const SUBSCRIPTION_EVENT = "standalonePerformanceSubscription"
const SUBSCRIPTION_ADD_EVENT = "standalonePerformanceSubscriptionAdd"
const SUBSCRIPTION_REMOVE_EVENT = "standalonePerformanceSubscriptionRemove"
const UNSUBSCRIBE_EVENT = "standalonePerformanceUnsubscribe"

export type StandalonePeriod = number | "MTD"

interface StandaloneSubscriptionPayload {
  modelProviderIds: string[]
  modelId: string
  period: StandalonePeriod
}

interface StandaloneUnsubscribePayload {
  modelId: string
  period: StandalonePeriod
}

export function subscribeToStandalonePerformance(
  socket: Socket,
  modelProviderIds: string[],
  modelId: string,
  period: StandalonePeriod,
): void {
  socket.emit(SUBSCRIPTION_EVENT, {
    modelProviderIds,
    modelId,
    period,
  } satisfies StandaloneSubscriptionPayload)
}

export function addStandaloneSubscription(
  socket: Socket,
  modelProviderIds: string[],
  modelId: string,
  period: StandalonePeriod,
): void {
  if (modelProviderIds.length === 0) return

  socket.emit(SUBSCRIPTION_ADD_EVENT, {
    modelProviderIds,
    modelId,
    period,
  } satisfies StandaloneSubscriptionPayload)
}

export function removeStandaloneSubscription(
  socket: Socket,
  modelProviderIds: string[],
  modelId: string,
  period: StandalonePeriod,
): void {
  if (modelProviderIds.length === 0) return

  socket.emit(SUBSCRIPTION_REMOVE_EVENT, {
    modelProviderIds,
    modelId,
    period,
  } satisfies StandaloneSubscriptionPayload)
}

export function unsubscribeFromStandalonePerformance(
  socket: Socket,
  modelId: string,
  period: StandalonePeriod,
): void {
  socket.emit(UNSUBSCRIBE_EVENT, {
    modelId,
    period,
  } satisfies StandaloneUnsubscribePayload)
}
